import { Dialog, DialogProps } from '@primer/react/drafts';
import React from 'react';
import { useCommonContext } from '../../../contexts/common';
import { isCloseByOutsideClick } from './outsideClickGuard';
interface IMyModalProps extends DialogProps {
    children?: React.ReactNode,
    titleComponent?: React.ReactNode
    onClose: () => void,
    width?: "small" | "medium" | "large" | "xlarge" | any;
    // height?: any,
    isOpen?: boolean,
    // isNobody?: boolean
    /** Mặc định false: bấm ra ngoài modal KHÔNG đóng modal. Truyền true nếu muốn cho phép đóng khi bấm ra ngoài. */
    shouldCloseOnOverlayClick?: boolean;
}
const MyModal = (props: IMyModalProps) => {
    const { translate } = useCommonContext();

    const isRightDrawer = props.position === 'right';
    const mergedSx = isRightDrawer
        ? {
            '& .DialogOverflowWrapper': {
                display: 'flex',
                flexDirection: 'column',
                '& > div': {
                    display: 'flex',
                    flexDirection: 'column',
                    flexGrow: 1,
                    '& > form': {
                        display: 'flex',
                        flexDirection: 'column',
                        flexGrow: 1,
                    },
                },
            },
            ...(props.sx || {}),
        }
        : props.sx;

    return (
        <>
            {props.isOpen &&
                <Dialog
                    title={props.title ? translate(props.title?.toString()) : props.titleComponent}
                    subtitle={props.subtitle ? translate(props.subtitle?.toString()) : undefined}
                    // isOpen={props.isOpen}
                    width={props.width}
                    height={props.height}
                    position={props.position}
                    sx={mergedSx}
                    onClose={(gesture: any) => {
                        // Chỉ đóng khi click vào nút close-button, trừ khi shouldCloseOnOverlayClick = true
                        if (gesture === 'close-button' || (props.shouldCloseOnOverlayClick === true && gesture === 'backdrop')) {
                            props.onClose();
                        }
                    }}
                    renderHeader={props.renderHeader}
                    renderFooter={props.renderFooter}

                // aria-labelledby="hello"
                >
                    {props.children}
                </Dialog>
            }
        </>
    );
};

export default MyModal;
